module.exports = __webpack_public_path__ + "img/cloud-apps.688e7ff2.png";